import * as React from "react";
import { observer } from "mobx-react";
import { Card, Input, Button, Select, Form } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { CustomFormItem } from "Components/Form/CustomFormItem";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { QACategorySelect } from "./QACategorySelect";
import { Status, qaStatusMap } from "./Status";

interface QASearchFormProps extends WithTranslation, ModalComponentProps {
  handleSearchSubmit: (formData: API_QASearch) => Promise<void>;
  allowedAskedBy: boolean;
  availableCategories?: API_Category[];
  availableStatus?: API_QASEARCH_STATUS[];
  availableAskedBy?: API_NameAndId[];
}

interface QASearchFormState {
  loading: boolean;
}

export const QASearchForm = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<QASearchFormProps, QASearchFormState> {
      readonly state: QASearchFormState = { loading: false };

      handleFinish = async (values: API_QASearch) => {
        try {
          this.setState({ loading: true });
          await this.props.handleSearchSubmit(values);
          this.props.hideModal();
        } catch (err) {
          throw err;
        } finally {
          this.setState({ loading: false });
        }
      };
      get statusEnums(): API_QUESTION_STATUS[] {
        if (this.props.availableStatus) {
          return this.props.availableStatus;
        } else {
          return Object.keys(qaStatusMap) as API_QUESTION_STATUS[];
        }
      }

      render() {
        const { t, allowedAskedBy, availableCategories } = this.props;
        return (
          <Form onFinish={this.handleFinish} scrollToFirstError={true}>
            <Card variant="outlined" styles={{ body: { padding: "24px 0" } }}>
              <CustomFormItem label={t("Category")}>
                <Form.Item noStyle name="categoryId">
                  <QACategorySelect categories={availableCategories} allowClear={true} />
                </Form.Item>
              </CustomFormItem>
              <CustomFormItem label={t("Topic")}>
                <Form.Item noStyle name="topic">
                  <Input placeholder={t("Topic")} />
                </Form.Item>
              </CustomFormItem>
              <CustomFormItem label={t("Question")}>
                <Form.Item noStyle name="question">
                  <Input placeholder={t("Question")} />
                </Form.Item>
              </CustomFormItem>
              <CustomFormItem label={t("Answer")}>
                <Form.Item noStyle name="answer">
                  <Input placeholder={t("Answer")} />
                </Form.Item>
              </CustomFormItem>
              {allowedAskedBy && (
                <CustomFormItem label={t("Asked by")}>
                  <Form.Item noStyle name="ownerId">
                    <Select allowClear={true}>
                      {this.props.availableAskedBy.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </CustomFormItem>
              )}
              <CustomFormItem label={t("Status")}>
                <Form.Item noStyle name="status">
                  <Select allowClear={true}>
                    {this.statusEnums.map((item) => (
                      <Select.Option key={item} value={item}>
                        <Status type={item} />
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </CustomFormItem>
            </Card>
            <ButtonsRow>
              <Button type="primary" htmlType="submit" loading={this.state.loading} style={{ fontSize: "15px" }}>
                {t("Search")}
              </Button>
            </ButtonsRow>
          </Form>
        );
      }
    }
  )
);
